import React from 'react';

import classes from './EditTopicForm.module.css';

import Button from '../../UI/Button/Button';
import Input from '../../UI/Input/Input';
import FormFields from '../FormFields';
import { IsObjectEmpty, IsListEmpty, IsStringEmpty, Log, GetObjectClone } from '../../../utilities/CommonMethods';
import CloseIcon from "../../../assets/icons/icon-close-black.png";
import FlexModal from '../../UI/FlexModal/FlexModal';
import { parseTimeForInputField } from '../../../utilities/DateTimeUtils';

class EditTopicForm extends React.Component {

    state = {
        editTopicForm: GetObjectClone(FormFields.editTopicForm),
        editTopicFormValid: false,
        showError: false,
        errorMessage: ''
    }

    checkValidity = (formElement) => {
        let isValid = true;

        const rules = formElement.validation;
        let value = formElement.value;

        if (!IsObjectEmpty(formElement.validation)) {
            const rules = formElement.validation;
            if (!IsObjectEmpty(rules.required) && rules.required.value) {
                if (typeof (value) === 'string' && value !== ' ' && value !== '' && value.length > 0) {
                    isValid = true && isValid;
                } else {
                    isValid = false;
                }
                formElement.errorMessage = isValid ? '' : rules.required.errorMessage;
                formElement.valid = isValid;
            }
        }

        if (!IsObjectEmpty(rules.date)) {
            if (rules.date.value && !IsStringEmpty(value) && formElement.label === 'Date') {
                const parsedDate = IsStringEmpty(value) ? '' : new Date(value);
                if (IsStringEmpty(parsedDate)) { // Schedule Date cannot be empty
                    isValid = false && isValid;
                    formElement.valid = isValid;
                    formElement.errorMessage = isValid ? '' : 'Schedule Date can not be empty';
                }
            }
        }

        return (formElement);
    }

    inputChangedHandler = (event, inputIdentifier) => {
        const updatedForm = { ...this.state.editTopicForm };
        let updatedFormElement = { ...updatedForm[inputIdentifier] };

        updatedFormElement.value = event.target.value;
        updatedFormElement.touched = true;
        updatedFormElement = this.checkValidity(updatedFormElement, updatedForm);
        updatedFormElement.valid = updatedFormElement.valid
        updatedForm[inputIdentifier] = updatedFormElement;
        let formIsValid = true;

        for (let inputIdentifier in updatedForm) {
            if (!IsObjectEmpty(updatedForm[inputIdentifier].validation.required) && updatedForm[inputIdentifier].validation.required.value) {
                formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
            }

            this.setState({ editTopicForm: updatedForm, editTopicFormValid: formIsValid });
        }
    }
    onFormButtonClicked = () => {
        const updatedForm = this.state.editTopicForm;
        for (let item in updatedForm) {
            updatedForm[item] = this.checkValidity(updatedForm[item], updatedForm);
        }

        let formIsValid = true;
        for (let inputIdentifier in updatedForm) {
            if (!IsObjectEmpty(updatedForm[inputIdentifier].validation.required) && updatedForm[inputIdentifier].validation.required.value) {
                formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
            }
        }

        // console.log('STatus before submit -> ', formIsValid, subtopicIsValid)
        this.setState({ editTopicForm: updatedForm, editTopicFormValid: formIsValid });

        if (formIsValid) {

            // alert('form is valid')

            const updatedTopicData = {};
            updatedTopicData["topic_name"] = this.state.editTopicForm.topicName.value;
            updatedTopicData["schedule_date"] = this.state.editTopicForm.scheduleDate.value;
            updatedTopicData["schedule_time"] = this.state.editTopicForm.scheduleTime.value;

            // console.log("Final Object => ", updatedTopicData);

            this.props.updateTopicData(updatedTopicData);

        }
    }

    setFormData = () => {
        const sessionPlanData = !IsObjectEmpty(this.props.data) ? this.props.data : {};
        if (sessionPlanData !== {}) {

            const topicName = !IsStringEmpty(sessionPlanData.title) ? sessionPlanData.title : '';

            const scheduleDate = sessionPlanData.scheduleDateTime[0],
                scheduleTime = parseTimeForInputField(sessionPlanData.scheduleDateTime[1]);


            let updatedFormData = { ...this.state.editTopicForm };
            updatedFormData['topicName'].value = topicName;
            updatedFormData['scheduleDate'].value = scheduleDate;
            updatedFormData['scheduleTime'].value = scheduleTime;

            if (this.props.liveSessionEnded === true) {
                updatedFormData['topicName'].disabled = true;
                updatedFormData['scheduleDate'].disabled = true;
                updatedFormData['scheduleTime'].disabled = true;
            } else {
                updatedFormData['scheduleDate'].disabled = false;
                updatedFormData['scheduleTime'].disabled = false;
            }

            this.setState({ editTopicForm: updatedFormData });


        } else {
            // alert('Adding a new Problem');
        }
    }

    componentDidMount() {
        this.setFormData();
    }

    inputField = (key) => {
        return <Input
            inputIdentifier={key}
            elementType={this.state.editTopicForm[key].elementType}
            elementConfig={this.state.editTopicForm[key].elementConfig}
            label={this.state.editTopicForm[key].label}
            value={this.state.editTopicForm[key].value}
            disabled={this.state.editTopicForm[key].disabled}
            options={this.state.editTopicForm[key].options}
            changed={(event) => this.inputChangedHandler(event, key)}
            touched={this.state.editTopicForm[key].touched}
            required={!IsObjectEmpty(this.state.editTopicForm[key].validation) ? (!IsObjectEmpty(this.state.editTopicForm[key].validation.required) ? this.state.editTopicForm[key].validation.required.value : false) : false}
            showError={(!this.state.editTopicFormValid && !this.state.editTopicForm[key].valid) ? true : false}
            error={this.state.editTopicForm[key].errorMessage} />
    }

    render() {
        return (
            <FlexModal visible={true} forSessionPlanForm={true} fullScreenMobile={true} backdropClicked={() => this.props.closePopup('')}>
                <div className={classes.Form}>
                    <h4 className={classes.Heading}>Update Topic</h4>

                    <img src={CloseIcon} alt={'Hide edit topic form'} className={classes.CloseIcon}
                        onClick={this.props.closePopup} />
                    <div>
                        {this.inputField('topicName')}
                    </div>
                    <div className={classes.DisplayFlex}>
                        {this.inputField('scheduleDate')}
                        {this.inputField('scheduleTime')}
                    </div>

                    <div className={classes.SubmitButton}>
                        <Button
                            styleclass="NonMobileOnly"
                            label={"UPDATE TOPIC"}
                            fontSize="0.8em"
                            padding="1em 3.5em"
                            margin="0 0 1.5em 0"
                            disabled={this.props.liveSessionEnded ? true : false}
                            clicked={this.props.liveSessionEnded ? null : this.onFormButtonClicked}
                        />
                    </div>
                </div>
            </FlexModal>
        );
    }

}

export default EditTopicForm;